import type { Observable } from 'rxjs';
import { EMPTY, of, tap } from 'rxjs';

import { ContentApi } from '@apps/main/modules/api/content/contentApi';
import { logException } from '@apps/main/modules/plugins/logException';

import { getHotelConstraint } from '@libs/search-service-smart-search';
import type {
  StaticInfoType,
  HotelConstraintQL,
  StaticInfoResponse,
} from '@libs/trip-planner-interfaces';

import { createCacheKey, hotelsCache } from './cache';

const contentApi = new ContentApi();

export function searchHotels<T extends StaticInfoType>(
  constraintQL: HotelConstraintQL,
  type: T
): Observable<StaticInfoResponse<T>> {
  // TODO: try improvements on cache (update same entry with new type instead of adding new entry)
  const key = createCacheKey(constraintQL, type);

  const cachedResult: StaticInfoResponse<T> | undefined = hotelsCache.get(
    key
  ) as StaticInfoResponse<T> | undefined;
  if (cachedResult) {
    return of(cachedResult);
  }
  return getHotelsFromEndpoint(constraintQL, type).pipe(
    tap((staticInfoResponse) => hotelsCache.insert(key, staticInfoResponse))
  );
}

function getHotelsFromEndpoint<T extends StaticInfoType>(
  constraintQL: HotelConstraintQL,
  type: T
): Observable<StaticInfoResponse<T>> {
  try {
    const constraint = getHotelConstraint(constraintQL);
    return contentApi.getHotels(
      constraint,
      constraint.selectedHotelTypes,
      type
    );
  } catch (error) {
    logException(error);

    return EMPTY;
  }
}
